import type { Feature, GeoJsonObject } from 'geojson';
import L from 'leaflet';
import type { GeoJSONTrafikenOptions } from './Layers.types';

const defaultOptions: GeoJSONTrafikenOptions = {
    source: null,
};

interface GeoJSONTrafiken {
    options: GeoJSONTrafikenOptions;
}

class GeoJSONTrafiken extends L.GeoJSON {
    constructor(data?: GeoJsonObject, options?: GeoJSONTrafikenOptions) {
        super(data, { ...defaultOptions, ...options });

        this.options.onEachFeature = (feature, layer) => {
            layer.bindPopup(new L.Popup(this.options.popupOptions).setContent(this.options.popupTemplate(feature.properties, this.options)));
        };
    }

    beforeAdd(map: L.Map): this {
        if (!this.hasData()) {
            map.fire('beforelayeradd', { layer: this });
        }

        return this;
    }

    onAdd(map: L.Map): this {
        if (!this.hasData()) {
            this.fire('data:loading');
            this.options.source.subscribe(this._onSourceUpdate);
        }
        return super.onAdd(map);
    }

    hasData(): boolean {
        return !!this.getLayers().length;
    }

    _onSourceUpdate = (data: Feature): void => {
        if (!this._map) {
            return;
        }

        this.clearLayers();
        this.addData(data);

        this.fire('data:loaded');
    };
}

export { GeoJSONTrafiken };
